import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EventKnightService {
  constructor(private apiService: ApiService) {}

  updateLocation(model: any) {
    console.log("updateLocation", model.beaconId);
    return this.apiService.postWithoutLoading(
      `/eventKnight/location/update`,
      model
    );
  }

  updateOutsideLocation(model: any) {
    return this.apiService.postWithoutLoading(
      `/eventKnight/location/notify-outside`,
      model
    );
  }

  updateListLocationBackground(model: any) {
    return this.apiService.postWithoutLoading(
      `/eventKnight/location/list/background-update`,
      model
    );
  }

  turnOffLocation() {
    return this.apiService.post(`/eventKnight/location/turnOff`);
  }

  getLocationStatus() {
    return this.apiService.get(`/eventKnight/location/status`);
  }

  getActiveEvent() {
    return this.apiService.get('/eventKnight/event/active');
  }

  filterEvent(type: string) {
    return this.apiService.get(`/eventKnight/event/filter/${type}`);
  }

  joinEvent(eventId: string) {
    return this.apiService.post(`/eventKnight/join/${eventId}`);
  }

  leaveEvent(eventId: string) {
    return this.apiService.post(`/eventKnight/leave/${eventId}`);
  }

  getEventDetails(eventId: string) {
    return this.apiService.get(`/eventKnight/event/${eventId}`);
  }

  getKnightSessions(eventId: string) {
    return this.apiService.get(`/eventKnight/session/${eventId}`);
  }

  getEventKnightSessions(eventId: string, knightId: string) {
    return this.apiService.get(`/eventKnight/session/${eventId}/${knightId}`);
  }

  getCheckInEntries() {
    return this.apiService.get(`/eventKnight/check-in/entries`);
  }

  getMyEventSchedules() {
    return this.apiService.get(`/eventKnight/schedule/my`);
  }

  getNearestShift() {
    return this.apiService.get(`/eventKnight/shift/nearest`);
  }

  startDuty() {
    return this.apiService.post(`/eventKnight/duty/start`);
  }

  startDutyV2(model: any) {
    return this.apiService.post(`/eventKnight/duty/start-v2`, model);
  }

  stopDuty() {
    return this.apiService.post(`/eventKnight/duty/stop`);
  }

  stopDutyV2(model: any) {
    return this.apiService.post(`/eventKnight/duty/stop-v2`, model);
  }


  startBreak() {
    return this.apiService.post(`/eventKnight/duty/start-break`);
  }

  stopBreak() {
    return this.apiService.post(`/eventKnight/duty/stop-break`);
  }

  getMyRosters() {
    return this.apiService.get(`/eventKnight/my-rosters`);
  }

  getMyShift(rosterId: string) {
    return this.apiService.get(`/eventKnight/my-shift/${rosterId}`);
  }

  getWorkingShift(rosterId: string, shiftId: string) {
    return this.apiService.get(
      `/eventKnight/shift/working/${rosterId}/${shiftId}`
    );
  }


  getWorkingShiftV2(rsaId: string) {
    return this.apiService.get(
      `/eventKnight/shift/working-v2/${rsaId}`
    );
  }

  getMapDashboardFilter(model: any) {
    return this.apiService.post(
      `/eventKnight/staff-map-dashboard-filter`,
      model
    );
  }

  filterGeofences(model: any) {
    if (model.isReNewCache)
      return this.apiService.post(`/eventKnight/filter-geofences`, model);

    return this.apiService.post(
      `/eventKnight/filter-geofences?isNoLoading=true`,
      model
    );
  }

  getUserRosterAndShift(staffId: string, model: any) {
    return this.apiService.post(
      `/eventKnight/staff/roster-shift/${staffId}`,
      model
    );
  }

  dashboardShiftFilter(
    rosterId: string,
    shiftId: string,
    isReNewCache: boolean = true
  ) {
    // "filter-geofences/shift/{rosterId}/{shiftId}/{isRenewCache}"
    if (!isReNewCache)
      return this.apiService.get(
        `/eventKnight/filter-geofences/shift/${rosterId}/${shiftId}/${isReNewCache}?isNoLoading=true`
      );

    return this.apiService.get(
      `/eventKnight/filter-geofences/shift/${rosterId}/${shiftId}/${isReNewCache}`
    );
  }

  checkUser(userId: string) {
    return this.apiService.get(
      `/eventKnight/live-stream/${userId}?isNoLoading=true`
    );
  }

  getStatusStyle(status: string) {
    let transformStatus = '';
    let style = '';
    const defaultStyle =
      'width: 0.825rem; height: 0.825rem; border-radius: 50%; border: 2px solid white; display: block;';
    if(status.includes('On Duty'))
      style = defaultStyle + ' background-color: #43b581; border: none;';
    else
      style = defaultStyle + ' background-color: #747f8d; border: none;';

    // switch (status) {
    //   case 'Online':
    //     style = defaultStyle + ' background-color: #43b581; border: none;';
    //     transformStatus = 'Available';
    //     break;

    //   case 'OnDuty':
    //     style = defaultStyle + ' background-color: #59e7ed; border: none;';
    //     transformStatus = 'On Duty';
    //     break;

    //   case 'Available':
    //     style = defaultStyle + ' background-color: #43b581; border: none;';
    //     transformStatus = 'Available';
    //     break;

    //   case 'Busy':
    //     style = defaultStyle + ' background-color: #f04747; border: none;';
    //     transformStatus = 'Busy';
    //     break;

    //   case 'OnBreak':
    //     style =
    //       defaultStyle + ' background-color: #ffff; border: 2px solid #faa61a;';
    //     transformStatus = 'On Break';
    //     break;
    //   case 'Idle':
    //     style = defaultStyle + ' background-color: #faa61a; border: none;';
    //     transformStatus = 'Idle';
    //     break;

    //   case 'InEmergency':
    //     style = defaultStyle + ' background-color: #e11d48; border: none;';
    //     transformStatus = 'In Emergency';
    //     break;

    //   case 'DoNotDisturb':
    //     style = defaultStyle + ' background-color: #e11d48; border: none;';
    //     transformStatus = 'Do Not Disturb';
    //     break;

    //   case 'Offline':
    //     style = defaultStyle + ' background-color: #747f8d; border: none;';
    //     transformStatus = 'Offline';
    //     break;

    //   case 'Unknown':
    //   default:
    //     style = '';
    //     transformStatus = '';
    //     break;
    // }

    // if (!transformStatus) return null;
    return {
      transformStatus,
      style,
    };
  }

  adminStopDuty(userIds: any[] = []) {
    return this.apiService.post(`/eventKnight/admin/stop-duty`, userIds);
  }
}
